// @ts-nocheck
/* eslint-disable */
import SceneMarker from "./marker";

// http://jsfiddle.net/justin_c_rounds/Gd2S2/light/
export function getIntersection(a1, b1, a2, b2) {
	// if the lines intersect, the result contains the x and y of the intersection (treating the lines as infinite) and booleans for whether line segment 1 or line segment 2 contain the point
	let denominator, a, b, numerator1, numerator2, result = {
		x: null,
		y: null,
		onLine1: false,
		onLine2: false
	};
	denominator = ((b2.y - a2.y) * (b1.x - a1.x)) - ((b2.x - a2.x) * (b1.y - a1.y));
	if (denominator == 0) {
		return result;
	}
	a = a1.y - a2.y;
	b = a1.x - a2.x;
	numerator1 = ((b2.x - a2.x) * a) - ((b2.y - a2.y) * b);
	numerator2 = ((b1.x - a1.x) * a) - ((b1.y - a1.y) * b);
	a = numerator1 / denominator;
	b = numerator2 / denominator;

	result.x = a1.x + (a * (b1.x - a1.x));
	result.y = a1.y + (a * (b1.y - a1.y));

	// if line1 is a segment and line2 is infinite, they intersect if:
	if (a > 0 && a < 1) {
		result.onLine1 = true;
	}
	// if line2 is a segment and line1 is infinite, they intersect if:
	if (b > 0 && b < 1) {
		result.onLine2 = true;
	}
	// if line1 and line2 are segments, they intersect if both of the above are true
	return result;
}

export function isRectIntersection(box, point, prevPoint) {
	let inter1 = getIntersection({ x: box[0][0], y: box[0][1] }, { x: box[1][0], y: box[1][1] }, point, prevPoint);
	let inter2 = getIntersection({ x: box[1][0], y: box[0][1] }, { x: box[0][0], y: box[1][1] }, point, prevPoint);


	if (inter1.x && inter1.onLine1 && inter1.onLine2 || inter2.x && inter2.onLine1 && inter2.onLine2) {
		return true;
	}

	return false;
}

export default class SceneMarkerBubble extends SceneMarker {
	/**
	 * Vytvoreni markeru bubliny.
	 *
	 * @param  {SceneCoords} coords Souradnice
	 * @param  {Number|String} [id] Volitelne ID
	 * @param  {Object} [opts] Volitelny objekt s konfiguraci
	 */
	constructor(scene, itemId, coords, id, opts) {
		let _opts = {
			angle: 45,
			arrowLength: 32,
			arrowCenter: [16,16],
			bubbleHeight: 32,
			bubbleWidth: 110
		};

		for (let p in opts) { _opts[p] = opts[p]; }

		// nechceme pro 3d
		if ("m3dData" in _opts) {
			_opts.m3dData.onlyMap = true;
		}
		else {
			_opts.m3dData = {
				onlyMap: true
			};
		}

		super(scene, itemId, coords, id, _opts);
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	get featureInfo() {
		return {
			name: "SceneMarkerBubble",
			type: "marker"
		};
	}

	set arrowAngle(angle) {
		this._options.angle = angle;

		this._onChange(this._scene.featureEvent("markerBubbleSetArrowAngle", true, true), arguments);
	}

	get arrowAngle() {
		return this._options.angle;
	}

	set innerElement(elm) {
		this._options.elm = elm;

		this._onChange(this._scene.featureEvent("markerBubbleSetInnerElement", true, true), arguments);
	}

	get BBox() {
		let right = this._options.angle > 180;

		let al = this._options.arrowLength;
		let degrees = 180 + this._options.angle;
		let anchorLeft = this._options.arrowCenter[0] + ((al*Math.sin(degrees*Math.PI/180))*(right ? -1 : 1));
		let anchorTop = this._options.arrowCenter[1] - (al*Math.cos(degrees*Math.PI/180));
		let pixels = this._scene.coordsToPixel(this._coords);
		let left = pixels.x - anchorLeft;
		let top = pixels.y - anchorTop;

		return [[left, top], [this._options.bubbleWidth + left, this._options.bubbleHeight + top]];
	}

	/**
	 * pokus o vyreseni kolizi, ke kterym dochazi mezi markerem a geometrii routy
	 * @private
	 * @param  {Array} geomPixels pole poli pixelovych souradnic geometrii
	 * @param  {Integer} toAngle do jakeho uhlu se ma pocitat
	 * @param  {Integer} fromAngle od jakeho uhlu se ma pocitat
	 * @return {Boolean}        zdali doslo k repozicovani markeru
	 */
	resolveColision(geomPixels, toAngle = 359, fromAngle = 0) {
		let maxAngle = 359;
		let angleSteps = 20;
		let resolve = false;
		let zoomColisions = [];

		if (!(geomPixels[0] instanceof Array)) {
			geomPixels = [geomPixels];
		}

		if (this.arrowAngle < fromAngle) {
			this.arrowAngle = fromAngle;
		}

		if (this.arrowAngle > toAngle) {
			this.arrowAngle = toAngle;
		}

		let inRect = (box, point) => {
			return point.x > Math.min(box[0][0], box[1][0])-5 && point.x < Math.max(box[0][0], box[1][0])+5 && point.y > Math.min(box[0][1], box[1][1])-5 && point.y < Math.max(box[0][1], box[1][1])+5;
		}

		let colision = maxColision => {
			let bbox = this.BBox;
			let colision = 0;

			if (!maxColision) {
				maxColision = Infinity;
			}

			geomPixels.forEach(pixels => {
				for (let i = 0; i < pixels.length; i++) {
					let px = pixels[i];
					if (inRect(bbox, px)) {
						colision++;
						if (colision > maxColision) {
							break;
						}
					}
					else if (i > 0 && isRectIntersection(bbox, px, pixels[i-1])){
						colision++;
						if (colision > maxColision) {
							break;
						}
					}
				}
			});

			return colision;
		}

		if (colision()) {
			let min = 0;
			for (let step = 0; step <= angleSteps; step++) {
				if (maxAngle/angleSteps*step <= toAngle && maxAngle/angleSteps*step >= fromAngle) {
					this.arrowAngle = maxAngle/angleSteps*step;
					let c = colision(zoomColisions[min] ? zoomColisions[min].colisions : Infinity);

					if (!c) {
						resolve = true;
						break;
					}

					zoomColisions.push({
						colisions: c,
						angle: maxAngle/angleSteps*step
					});

					if (zoomColisions[min].colisions > c.colisions) {
						min = step;
					}
				}
			}

			if (!resolve && zoomColisions.length) {
				let sort = zoomColisions.slice();
				sort.sort((a,b) => {
					return a.colisions-b.colisions;
				});
				this.arrowAngle = sort[0].angle;
			}
		}
		else {
			resolve = true;
		}

		return resolve;
	}

	intersectOtherMarker(marker) {
		let m1 = this.BBox;
		let m2 = marker.BBox;
		let xOverlap = Math.max(0, Math.min(m1[1][0],m2[1][0]) - Math.max(m1[0][0],m2[0][0]));
		let yOverlap = Math.max(0, Math.min(m1[1][1],m2[1][1]) - Math.max(m1[0][1],m2[0][1]));

		return !!(xOverlap * yOverlap);
	}

	toggleClassName(method, className) {
		this._onChange(this._scene.featureEvent("markerBubbleToggleClassName", true, true), arguments);
	}

	setInnerElement(element) {
		this._onChange(this._scene.featureEvent("markerBubbleSetInnerElement", true, true), arguments);
	}

	setOptions(options) {
		for (const p in options) { this._options[p] = options[p]; }

		this._onChange(this._scene.featureEvent("markerBubbleSetOptions", true, true), arguments);
	}
}
